/**
 * Build a Google Maps search URL from venue address fields. Empty/null parts
 * are dropped so a partial address (e.g. city + state only) still yields a
 * usable link.
 */
export function buildMapsUrl(
  address?: string | null,
  city?: string | null,
  state?: string | null,
  postalCode?: string | null,
): string {
  const parts = [address, city, state, postalCode].filter(Boolean).join(", ");
  return `https://www.google.com/maps?q=${encodeURIComponent(parts)}`;
}
